import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-50" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  role: "list",
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3"
}
const _hoisted_4 = { class: "group col-span-1 flex shadow-sm rounded-2xl cursor-pointer" }
const _hoisted_5 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_6 = { class: "flex-shrink-0 pl-4 pr-4 flex items-center justify-center" }
const _hoisted_7 = { class: "group col-span-1 flex shadow-sm rounded-2xl cursor-pointer" }
const _hoisted_8 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_9 = { class: "flex-shrink-0 pl-4 pr-4 flex items-center justify-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-brand-secondary text-md font-medium uppercase tracking-wide" }, "Select a Modem", -1)
const _hoisted_12 = { class: "mt-4 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4" }

import { ref } from 'vue';
import HardwareSelectorProduct from './HardwareSelectorProduct.vue';
import { CheckCircleIcon } from '@heroicons/vue/outline';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    products: { type: Array, required: true },
    isHardwareAdded: { type: Boolean, required: true },
    selected: { type: String, required: true }
  },
  emits: ["onHardwareSelected", "onHardwareToggled"],
  setup(__props: any, { emit }: { emit: ({(e: 'onHardwareSelected', id: string): void, (e: 'onHardwareToggled', isVoipAdded: boolean): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  products: Array<Product>,
  isHardwareAdded: boolean,
  selected: string
}





const hardwareProductAdded = ref(false);
const productSelected = ref<Product|null>();

const handleClickAddHardwareProduct = () => {
  hardwareProductAdded.value = true;
  emit('onHardwareToggled', true);
};

const handleClickRemoveHardwareProduct = () => {
  hardwareProductAdded.value = false;
  emit('onHardwareToggled', false);
};

const handleSelectProduct = (product: Product): void => {
  productSelected.value = product;
  emit('onHardwareSelected', product.id);
};

const isSelectedProduct = (product: Product): boolean => {
  return product.id === props.selected;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("div", {
            onClick: handleClickAddHardwareProduct,
            class: _normalizeClass(["transition duration-250", [(hardwareProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-xl transition duration-250 text-black", [hardwareProductAdded.value ? 'text-black' : 'text-black']])
              }, "Yes", 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["w-8 h-8 bg-white inline-flex items-center justify-center rounded-full bg-transparent", [ hardwareProductAdded.value ? 'text-black' : 'text-black' ]])
              }, [
                (hardwareProductAdded.value)
                  ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                      key: 0,
                      class: "w-8 h-8",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("div", {
            onClick: handleClickRemoveHardwareProduct,
            class: _normalizeClass(["transition duration-250", [(!hardwareProductAdded.value ? 'border border-black' : 'border border-gray-200'), ('flex-1 flex items-center justify-between bg-white rounded-2xl truncate')]])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                class: _normalizeClass(["text-xl transition duration-250 text-black", [ !hardwareProductAdded.value ? 'text-black' : 'text-black' ]])
              }, "No", 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["w-8 h-8 bg-white inline-flex items-center justify-center rounded-full bg-transparent", [ !hardwareProductAdded.value ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
              }, [
                (!hardwareProductAdded.value)
                  ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                      key: 0,
                      class: "w-8 h-8",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ], 2)
        ])
      ]),
      (hardwareProductAdded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
                return (_openBlock(), _createBlock(HardwareSelectorProduct, {
                  onHandleSelectProduct: handleSelectProduct,
                  product: product,
                  key: product.name,
                  isSelectedProduct: isSelectedProduct(product)
                }, null, 8, ["product", "isSelectedProduct"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})